import { render, staticRenderFns } from "./MaterialGroupInputTab.vue?vue&type=template&id=3c0dea72&scoped=true&"
import script from "./MaterialGroupInputTab.vue?vue&type=script&lang=js&"
export * from "./MaterialGroupInputTab.vue?vue&type=script&lang=js&"
import style0 from "./MaterialGroupInputTab.vue?vue&type=style&index=0&id=3c0dea72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0dea72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardSubtitle,VCardTitle,VCol,VForm,VIcon,VSelect,VSimpleTable,VTextField})
